var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a',{attrs:{"id":"author","href":"https://seele-exzzz-github-io.pages.dev/","target":"_blank"}},[_vm._v(" 个人博客 ")]),_c('div',{attrs:{"id":"earth"}})])
}]

export { render, staticRenderFns }